export const TITULOS_RESULTADO_MAPS = {
  TIENDA: 'label_tienda',
  GASTRONOMIA: 'label_title_gastronomia',
  SERVICIOS: 'label_title_servicios'
};
